<section class="bloco-exportacao">
  <div class="exportacao-inner">

    <div class="exportacao-grupo">
      <span class="exportacao-label">
        <mat-icon>file_download</mat-icon>
        Exportar obras
      </span>
      <div class="exportacao-botoes">
        <button class="btn-exportar btn-exportar--primary" (click)="exportImobiliario()">
          Imobiliário
        </button>
        <button class="btn-exportar btn-exportar--outline" (click)="exportIndustrial()">
          Industrial, Edificações e Infraestrutura
        </button>
      </div>
    </div>

    <span class="exportacao-separator">|</span>

    <div class="exportacao-grupo">
      <span class="exportacao-label">
        <mat-icon>history</mat-icon>
        Últimas exportações
      </span>
      <div class="exportacao-selects">
        <div class="select-wrapper">
          <select
            name="dataImobiliario"
            id="dataImobiliario"
            (change)="onDateChangeImobiliario($event)"
          >
            <option value="">Imobiliário</option>
            @for (item of exportacaoImobiliario; track $index) {
              <option [value]="item.date">{{ item.dateText }}</option>
            }
          </select>
        </div>
        <div class="select-wrapper">
          <select
            id="dataIndustrial"
            name="dataIndustrial"
            (change)="onDateChangeIndustrial($event)"
          >
            <option value="">Industrial, Edif. e Infra.</option>
            @for (item of exportacaoIndustrial; track $index) {
              <option [value]="item.date">{{ item.dateText }}</option>
            }
          </select>
        </div>
      </div>
    </div>

  </div>
</section>

@if (isLoading) {
  <app-common-loader></app-common-loader>
}